import { Button, Grid2, Stack, Tab, Tabs, Typography } from "@mui/material";
import ContainerLoading from "../components/ContainerLoading";
import { useEffect, useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { updateStoreUser } from "../services/store";
import { formatCpfCnpj, formatPhone, unMask } from "../helpers/format";
import {
  getUser,
  sendTokenByUserId,
  validateUserToken,
} from "../services/user";
import { useFormik } from "formik";
import { Input } from "../components/Input";
import { IconBarbell, IconKey, IconPhone } from "@tabler/icons-react";
import { toast } from "react-toastify";
import OtpInput from "react-otp-input";
import {
  forgotPassWord,
  updatePassByToken,
  validateToken,
} from "../services/auth";
import PageHeader from "../components/PageHeader";

const MyUser = () => {
  const [value, setValue] = useState("1");
  const [newPhone, setNewPhone] = useState("");
  const [password, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [otpPassword, setOtpPassword] = useState("");
  const [stepChangePhone, setStepChangePhone] = useState(1);
  const [stepForgotPassword, setStepForgotPassword] = useState(1);

  const handleChangeValue = (
    _event: React.SyntheticEvent,
    newValue: string
  ) => {
    setValue(newValue);
  };

  const {
    data: dataUser,
    isLoading: isLoadingUser,
    isFetching: isFetchingUser,
    refetch: refetchUser,
  }: {
    data: {
      user: {
        id: string;
        name: string;
        email: string;
        document: string;
        phone: string;
      };
    };
    isLoading: boolean;
    isFetching: boolean;
    refetch: () => void;
  } = useQuery({
    queryKey: ["getUser"],
    queryFn: getUser,
    initialData: { store: {}, user: {} },
  });

  const { mutate, isPending } = useMutation({
    mutationFn: updateStoreUser,
    onSuccess: () => {
      refetchUser();
      toast.success("Dados do usuário atualizado");
    },

    onError: (e: { response: { data: { message: string } } }) => {
      toast.error(String(e?.response?.data?.message) || "Erro!");
    },
  });

  const { mutate: mutateSendToken, isPending: isPendingSendToken } =
    useMutation({
      mutationFn: async () =>
        await sendTokenByUserId({ phone: unMask(newPhone) }),
      onSuccess: () => {
        setStepChangePhone(stepChangePhone + 1);
      },
      onError: (e: { response: { data: { message: string } } }) => {
        toast.error(String(e?.response?.data?.message) || "Erro!");
      },
    });

  const { mutate: mutateToken, isPending: isPendingToken } = useMutation({
    mutationFn: async () =>
      await validateUserToken({ token: otp, phone: unMask(newPhone) }),
    onSuccess: () => {
      setStepChangePhone(1);
      setValue("1");
      refetchUser();
      toast.success("Telefone alterado com sucesso");
    },
    onError: (e: { response: { data: { message: string } } }) => {
      toast.error(String(e?.response?.data?.message) || "Erro!");
    },
  });

  const { mutate: mutateForgotPassword, isPending: isPendingForgotPassword } =
    useMutation({
      mutationFn: forgotPassWord,
      onSuccess: () => {
        toast.success("Enviamos um WhatsApp para seu número!");
        setStepForgotPassword(stepForgotPassword + 1);
      },
      onError: (e: { response: { data: { message: string } } }) => {
        toast.error(String(e?.response?.data?.message) || "Erro!");
      },
    });

  const { mutate: mutateTokenPassword, isPending: isPendingTokenPassword } =
    useMutation({
      mutationFn: async () => await validateToken({ token: otpPassword }),
      onSuccess: () => {
        setStepForgotPassword(stepForgotPassword + 1);
      },
      onError: (e: { response: { data: { message: string } } }) => {
        toast.error(String(e?.response?.data?.message) || "Erro!");
      },
    });

  const { mutate: mutatePassword, isPending: isPendingPassword } = useMutation({
    mutationFn: async () =>
      await updatePassByToken({ token: otpPassword, password }),
    onSuccess: () => {
      setStepForgotPassword(1);
      setValue("1");
      refetchUser();
      toast.success("Senha alterada com sucesso!");
    },
    onError: (e: { response: { data: { message: string } } }) => {
      toast.error(String(e?.response?.data?.message) || "Erro!");
    },
  });

  const { values, handleChange, setFieldValue, handleSubmit } = useFormik({
    initialValues: {
      id: "",
      name: "",
      email: "",
      document: "",
      phone: "",
    },
    onSubmit: (values) => {
      if (!values.name) {
        toast.info("Preencha o nome do usuário");
        return;
      }
      if (!values.email) {
        toast.info("Preencha o email do usuário");
        return;
      }

      mutate(values);
    },
  });

  useEffect(() => {
    if (dataUser) {
      setFieldValue("id", dataUser?.user?.id);
      setFieldValue("name", dataUser?.user?.name);
      setFieldValue("email", dataUser?.user?.email);
      setFieldValue("phone", dataUser?.user?.phone);
      setFieldValue("document", dataUser?.user?.document);
    }
  }, [dataUser]);

  const loading =
    isLoadingUser ||
    isFetchingUser ||
    isPending ||
    isPendingSendToken ||
    isPendingToken ||
    isPendingForgotPassword ||
    isPendingTokenPassword ||
    isPendingPassword;
  return (
    <ContainerLoading loading={loading}>
      <Grid2 container spacing={2} padding={2}>
        <PageHeader
          title=" Meu usuário"
          subtitle="Informações gerais do usuário."
        />
        <Grid2 size={12}>
          <Tabs
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              marginBottom: 2,
            }}
            onChange={handleChangeValue}
            value={value}
            textColor="inherit"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="Dados do usuário" value="1" />
            <Tab label="Alterar telefone" value="2" />
            <Tab label="Alterar senha" value="3" />
          </Tabs>
        </Grid2>
        {value === "1" && (
          <Grid2 size={12}>
            <Grid2 container spacing={2}>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Input
                  id="name"
                  name="name"
                  label="Nome"
                  type="text"
                  fullWidth
                  size="small"
                  value={values.name}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Input
                  id="email"
                  name="email"
                  label="E-mail"
                  type="text"
                  fullWidth
                  size="small"
                  value={values.email}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Input
                  id="document"
                  name="document"
                  label="CPF"
                  type="text"
                  disabled
                  fullWidth
                  size="small"
                  value={formatCpfCnpj(values.document)}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Input
                  id="phone"
                  name="phone"
                  label="Telefone"
                  type="text"
                  disabled
                  fullWidth
                  size="small"
                  value={formatPhone(values.phone)}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 size={12}>
                <Stack
                  sx={{
                    flexDirection: "row",
                    alignItems: "flex-end",
                    width: "100%",
                    justifyContent: "flex-end",
                    height: "100%",
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{ gap: 0.5 }}
                    onClick={() => handleSubmit()}
                  >
                    <IconBarbell size={18} />
                    <Typography variant="body2">Atualizar dados</Typography>
                  </Button>
                </Stack>
              </Grid2>
            </Grid2>
          </Grid2>
        )}
        {value === "2" && (
          <Grid2 size={12}>
            {stepChangePhone === 1 && (
              <Grid2 container spacing={2}>
                <Grid2 size={12}>
                  <Typography variant="h2" fontWeight={600} fontSize={24}>
                    Atualizar telefone
                  </Typography>
                  <Typography
                    variant="h2"
                    fontWeight={600}
                    fontSize={14}
                    color="secondary.contrastText"
                  >
                    Enviaremos um código de redefinição de telefone para o seu
                    novo número!
                  </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }}>
                  <Input
                    id="newPhone"
                    name="newPhone"
                    label="Novo telefone"
                    type="text"
                    fullWidth
                    size="small"
                    value={formatPhone(newPhone)}
                    onChange={(e) => setNewPhone(e.target.value)}
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }}>
                  <Stack
                    sx={{
                      flexDirection: "row",
                      alignItems: "flex-end",
                      width: "100%",
                      justifyContent: "flex-end",
                      height: "100%",
                    }}
                  >
                    <Button
                      variant="contained"
                      sx={{ gap: 0.5 }}
                      onClick={() => mutateSendToken()}
                    >
                      <IconPhone size={18} />
                      <Typography variant="body2">
                        Atualizar Telefone
                      </Typography>
                    </Button>
                  </Stack>
                </Grid2>
              </Grid2>
            )}
            {stepChangePhone === 2 && (
              <Grid2 container spacing={2}>
                <Grid2 size={12}>
                  <Typography variant="h2" fontWeight={600} fontSize={24}>
                    Enviamos um token para o seu telefone
                  </Typography>
                  <Typography
                    variant="h2"
                    fontWeight={600}
                    fontSize={14}
                    color="secondary.contrastText"
                  >
                    Digite o token que enviamos para o seu telefone para
                    realizar a alteração do número.
                  </Typography>
                </Grid2>
                <Grid2 size={12}>
                  <Stack spacing={4} alignItems="center">
                    <OtpInput
                      value={otp}
                      onChange={setOtp}
                      numInputs={5}
                      renderInput={(props) => <input {...props} />}
                      containerStyle={{ gap: 10 }}
                      inputStyle={{
                        height: "60px",
                        width: "50px",
                        fontSize: "32px",
                        fontWeight: 600,
                        color: "primary.contrastText",
                        backgroundColor: "secondary.light",
                        borderRadius: "10px",
                        borderStyle: "solid",
                        borderColor: "secondary.contrastext",
                      }}
                    />
                    <Button
                      variant="contained"
                      sx={{ width: "82%" }}
                      size="large"
                      color="primary"
                      onClick={() => {
                        if (!otp) {
                          toast.error("Digite o token!");
                          return;
                        }
                        mutateToken();
                      }}
                    >
                      Confirmar
                    </Button>
                  </Stack>
                </Grid2>
              </Grid2>
            )}
          </Grid2>
        )}
        {value === "3" && (
          <Grid2 size={12}>
            {stepForgotPassword === 1 && (
              <Grid2 container spacing={2}>
                <Grid2 size={12}>
                  <Typography variant="h2" fontWeight={600} fontSize={24}>
                    Alterar minha senha
                  </Typography>
                  <Typography
                    variant="h2"
                    fontWeight={600}
                    fontSize={14}
                    color="secondary.contrastText"
                  >
                    Enviaremos um código da redefinição de senha para o número
                    de telefone {formatPhone(dataUser?.user?.phone)}
                  </Typography>
                </Grid2>
                <Grid2 size={12}>
                  <Stack
                    sx={{
                      flexDirection: "row",
                      alignItems: "flex-end",
                      width: "100%",
                      justifyContent: "flex-end",
                      height: "100%",
                    }}
                  >
                    <Button
                      variant="contained"
                      sx={{ gap: 0.5 }}
                      onClick={() =>
                        mutateForgotPassword({ phone: values.phone })
                      }
                    >
                      <IconKey size={18} />
                      <Typography variant="body2">
                        Enviar redefinição
                      </Typography>
                    </Button>
                  </Stack>
                </Grid2>
              </Grid2>
            )}
            {stepForgotPassword === 2 && (
              <Grid2 container spacing={2}>
                <Grid2 size={12}>
                  <Typography variant="h2" fontWeight={600} fontSize={24}>
                    Enviamos um token para o seu telefone
                  </Typography>
                  <Typography
                    variant="h2"
                    fontWeight={600}
                    fontSize={14}
                    color="secondary.contrastText"
                  >
                    Digite o token que enviamos para o seu telefone para
                    realizar a alteração da senha.
                  </Typography>
                </Grid2>
                <Grid2 size={12}>
                  <Stack spacing={4} alignItems="center">
                    <OtpInput
                      value={otpPassword}
                      onChange={setOtpPassword}
                      numInputs={5}
                      renderInput={(props) => <input {...props} />}
                      containerStyle={{ gap: 10 }}
                      inputStyle={{
                        height: "60px",
                        width: "50px",
                        fontSize: "32px",
                        fontWeight: 600,
                        color: "primary.contrastText",
                        backgroundColor: "secondary.light",
                        borderRadius: "10px",
                        borderStyle: "solid",
                        borderColor: "secondary.contrastext",
                      }}
                    />
                    <Button
                      variant="contained"
                      sx={{ width: "82%" }}
                      size="large"
                      color="primary"
                      onClick={() => {
                        if (!otpPassword) {
                          toast.error("Digite o token!");
                          return;
                        }
                        mutateTokenPassword();
                      }}
                    >
                      Confirmar
                    </Button>
                  </Stack>
                </Grid2>
              </Grid2>
            )}
            {stepForgotPassword === 3 && (
              <Grid2 container spacing={2}>
                <Grid2 size={12}>
                  <Typography variant="h2" fontWeight={600} fontSize={24}>
                    Digite a nova senha.
                  </Typography>
                  <Typography
                    variant="h2"
                    fontWeight={600}
                    fontSize={14}
                    color="secondary.contrastText"
                  >
                    Digite e confirme sua nova senha para realizar a
                    atualização.
                  </Typography>
                </Grid2>
                <Grid2 size={6}>
                  <Input
                    id="password"
                    name="password"
                    label="Nova senha"
                    type="password"
                    fullWidth
                    size="small"
                    value={password}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </Grid2>
                <Grid2 size={6}>
                  <Input
                    id="confirmPassword"
                    name="confirmPassword"
                    label="Confirmar nova senha"
                    type="password"
                    fullWidth
                    size="small"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </Grid2>
                <Grid2 size={12}>
                  <Stack
                    sx={{
                      flexDirection: "row",
                      alignItems: "flex-end",
                      width: "100%",
                      justifyContent: "flex-end",
                      height: "100%",
                    }}
                  >
                    <Button
                      variant="contained"
                      sx={{ gap: 0.5 }}
                      onClick={() => {
                        if (!password) {
                          toast.error("Digite a nova senha!");
                          return;
                        }
                        if (!confirmPassword) {
                          toast.error("Confirme a nova senha!");
                          return;
                        }
                        if (password !== confirmPassword) {
                          toast.error("As senhas não conferem!");
                          return;
                        }
                        mutatePassword();
                      }}
                    >
                      <IconKey size={18} />
                      <Typography variant="body2">Alterar senha</Typography>
                    </Button>
                  </Stack>
                </Grid2>
              </Grid2>
            )}
          </Grid2>
        )}
      </Grid2>
    </ContainerLoading>
  );
};

export default MyUser;
